export default "__VITE_ASSET__BC_9MsVY__";